<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Bank Soal', to: { path: '/items?mapel=1' } },
                { text: 'Laporan Soal' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div>
            <v-row>
                <v-col cols="12" md="10">
                    <h3 class="header-text font-weight-bold">Laporan Soal</h3>
                </v-col>

                <v-cols cols="12" md="2" class="align-right">
                    <div class="text-right mt-5">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-width="120"
                            offset-x
                        >
                            <template
                                v-slot:activator="{ on, attrs }"
                                class="text-right"
                            >
                                <span style="font-size: 16px">
                                    Filter &nbsp;&nbsp;</span
                                >
                                <v-btn
                                    depressed
                                    color="white"
                                    v-bind="attrs"
                                    v-on="on"
                                    width="120"
                                >
                                    <span class="blew--text">
                                        <span v-if="filter_type === 'ALL'"
                                            >Semua</span
                                        >
                                        <span v-if="filter_type === 'CUSTOM'"
                                            >Custom</span
                                        >
                                        <v-icon color="blew" small class="ml-6">
                                            mdi-chevron-down
                                        </v-icon>
                                    </span>
                                </v-btn>
                            </template>

                            <v-card class="pt-7" width="350">
                                <v-card-title>
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <div style="font-size: 14px">
                                                Rentang Tanggal
                                            </div>
                                            <div>
                                                <v-select
                                                    outlined
                                                    placeholder="Pilih Rentang Tanggal"
                                                    v-model="filter_type"
                                                    class="pa-0"
                                                    :items="[
                                                        {
                                                            text: 'Semua',
                                                            value: 'ALL',
                                                        },
                                                        {
                                                            text: 'Custom',
                                                            value: 'CUSTOM',
                                                        },
                                                    ]"
                                                ></v-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="filter_type === 'CUSTOM'">
                                        <v-col cols="12" md="12">
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Dari Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog"
                                                            v-model="modal_date"
                                                            :return-value.sync="
                                                                date
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog.save(
                                                                            date,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <div
                                                        style="font-size: 14px"
                                                    >
                                                        Sampai Tanggal
                                                    </div>
                                                    <div>
                                                        <v-dialog
                                                            ref="dialog2"
                                                            v-model="
                                                                modal_date2
                                                            "
                                                            :return-value.sync="
                                                                date2
                                                            "
                                                            persistent
                                                            width="290px"
                                                        >
                                                            <template
                                                                v-slot:activator="{
                                                                    on,
                                                                    attrs,
                                                                }"
                                                            >
                                                                <v-text-field
                                                                    v-model="
                                                                        date2
                                                                    "
                                                                    outlined
                                                                    dense
                                                                    readonly
                                                                    v-bind="
                                                                        attrs
                                                                    "
                                                                    v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                v-model="date2"
                                                                scrollable
                                                            >
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        modal_date2 = false
                                                                    "
                                                                >
                                                                    Cancel
                                                                </v-btn>
                                                                <v-btn
                                                                    text
                                                                    color="primary"
                                                                    @click="
                                                                        $refs.dialog2.save(
                                                                            date2,
                                                                        )
                                                                    "
                                                                >
                                                                    OK
                                                                </v-btn>
                                                            </v-date-picker>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-title>
                                <v-card-actions class="pb-5 pr-3">
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        rounded
                                        depressed
                                        @click="menu = false"
                                    >
                                        Batal
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        depressed
                                        color="primary"
                                        @click="doFilter()"
                                    >
                                        Terapkan
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </v-cols>
            </v-row>
        </div>

        <!-- <div class="mb-10 mt-2">
      <v-row>
        <v-col cols="3">
          <v-card flat class="mt-5">
            <v-card-text class="pa-5">
              <div class="grey--text">Total Semua Laporan</div>
              <div
                class="font-weight-700 black--text mt-2"
                style="font-size: 24px"
              >
                {{ total_problem }} <span style="font-size: 14px">Laporan</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3" v-for="(data, index) of problem" :key="index">
          <v-card flat class="mt-5">
            <v-card-text class="pa-5">
              <div class="grey--text">{{ data.problem_name }}</div>
              <div
                class="font-weight-700 black--text mt-2"
                style="font-size: 24px"
              >
                {{ data.count }}
                <span class="font-weight-400" style="font-size: 14px">
                  Laporan
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div> -->

        <v-card>
            <v-card-title> Laporan Soal </v-card-title>
            <v-divider />

            <app-datatable
                :items="reports"
                :headers="headers"
                :has-action="false"
                :has-export="true"
                :has-duplicate="true"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="total_item"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:exportClicked="exportTryout()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doSearch();
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import ItemBankService from "@/modules/itembank/services/itembank.js";
import Moment from "moment";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: "",
            total: 0,
            start_date: "",
            end_date: "",
            search: "",
            tableKey: "",
            sortBy: "",
            filters: "",
            reports: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            data: [],
            problem: [],
            total_problem: 0,
            total_item: 0,
            params: {
                page: 1,
                size: 0,
                sortMode: "desc",
                start_date: null,
                end_date: null,
                problem: "",
                other_problem: "",
                date: null,
                item_code: "",
                mapel: "",
            },
            headers: [
                { text: "Mata Pelajaran", value: "mapel_name", width: "150px" },
                { text: "Kode Soal", value: "item_code", width: "100px" },
                { text: "Tanggal", value: "created_at", width: "150px" },
                { text: "Alasan Laporan", value: "problem", width: "150px" },
                {
                    text: "Keluhan Lain",
                    value: "other_problem",
                    width: "200px",
                },
            ],
            filter_type: "ALL",
            menu: false,
            modal_date: false,
            modal_date2: false,
            date: "",
            date2: "",
        };
    },

    watch: {
        "pagination.currentPage": function (val) {
            this.params.page = val;
            this.fetchData();
        },
        pagination() {
            this.params.sortMode = this.pagination.sortMode;
            this.fetchData();
        },
        // filter_type() {
        //   if (this.filter_type === "ALL") {
        //     this.date = "";
        //     this.date2 = "";
        //   }
        // },
    },

    mounted: function () {
        this.fetchData();
        // this.fetchListProblem();
    },

    methods: {
        fetchData() {
            var context = this;
            this.isLoading = true;

            context.params.page = context.pagination.currentPage;
            context.params.size = context.pagination.perPage;

            ItemBankService.getListReports(this.params, (result) => {
                context.reports = [];

                context.total_item = result.data.total_item;
                context.pagination.totalPages = result.data.max_page;

                if (result.success) {
                    result.data.list_report.forEach(function (data, index) {
                        var row = {
                            no: index,
                            mapel_name: data.mapel.nama,
                            item_code: data.item_code,
                            created_at: Moment(data.created_at).format(
                                "DD MMMM YYYY",
                            ),
                            problem: data.problem,
                            other_problem: data.other_problem,
                        };
                        context.reports.push(row);
                        context.isLoading = false;
                    });
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
                context.isLoading = false;
            });
        },
        fetchListProblem() {
            const context = this;
            const param = `?date_from=${context.start_date}&date_to=${context.end_date}`;
            const url = `${process.env.API_BASE_URL}itembank-service/admin/report/detail${param}`;

            const authToken = JSON.parse(localStorage.getItem("token")).value;

            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.user_groups = [];
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.problem = response.data.total_report_problems;
                    context.total_problem = response.data.total_report;
                }
            });
        },
        doFilter() {
            var context = this;
            this.menu = false;

            if (this.filter_type === "ALL") {
                context.date = null;
                context.date2 = null;

                context.params.start_date = context.date;
                context.params.end_date = context.date2;
            } else {
                context.params.start_date = Moment(context.date).format(
                    "YYYY-MM-DD",
                );
                context.params.end_date = Moment(context.date2).format(
                    "YYYY-MM-DD",
                );
            }

            context.fetchData();
        },
        doSearch() {
            this.params.page = 1;
            this.pagination.currentPage = 1;

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.params[this.search.by] = this.search.query;
            }

            if (this.search.by === "mapel_name") {
                this.params.mapel = this.search.query;
            } else if (this.search.by === "item_code") {
                this.params.item_code = this.search.query;
            } else if (this.search.by === "problem") {
                this.params.problem = this.search.query;
            } else if (this.search.by === "other_problem") {
                this.params.other_problem = this.search.query;
            } else if (this.search.by === "created_at") {
                this.params.date = Moment(this.search.query).format(
                    "YYYY-MM-DD",
                );
                this.params.start_date = this.params.date;
                this.params.end_date = this.params.date;
            }

            this.fetchData();
            this.fetchListProblem();
        },

        clearFilter() {
            this.params = {
                sortMode: "desc",
                start_date: null,
                end_date: null,
                problem: "",
                other_problem: "",
                date: null,
                item_code: "",
                mapel: "",
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListReport.vue?7e02739c